export default __webpack_public_path__ + "static/media/congratsBanner.569d7ca1.png";